import React from 'react'
import { observer } from 'mobx-react'
import StaffingViewModel from 'admin/staffing/components/Staffing/StaffingViewModel'
import Button from 'components/Button'
import Icon from 'components/Icon'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from 'components/StickyViewHeader'
import WorkspaceFilterViewHeading from 'components/WorkspaceFilterViewHeading'
import { ScrollOffsetInterpolation } from 'hooks/spring-hooks'
import styles from './StaffingHeader.sass'

interface StaffingHeaderProps {
  scrollOffset: ScrollOffsetInterpolation
  vm: StaffingViewModel
}

export default observer(function StaffingHeader({
  vm,
  scrollOffset,
}: StaffingHeaderProps) {
  const searcher = vm.searcher
  return (
    <StickyViewHeader scrollOffset={scrollOffset}>
      <StickyViewHeaderMain>
        <WorkspaceFilterViewHeading
          allOptionText="All Workspaces"
          primaryText="Staffing Manager"
          filter={searcher.workspaceFilter}
        />
      </StickyViewHeaderMain>
      <StickyViewHeaderExtras>
        <Button type="secondary" onClick={vm.createWorkspacePostingVM.show}>
          <Icon name="add" size={16} />
          <span className={styles.text}>New Post</span>
        </Button>
      </StickyViewHeaderExtras>
    </StickyViewHeader>
  )
})
